// extracted by mini-css-extract-plugin
export default {"root":"ComboChoice_root__w37cr","form-control-label":"ComboChoice_form-control-label__FBipX","switch":"ComboChoice_switch__fu7om","label":"ComboChoice_label__8vV0W"};